import { exists, LendCount, LendCountFromJSON } from '@/api'

export interface LendGroupCount {
  groupId: number
  count: number
  limit: number
  details: LendCount[]
}

export function LendGroupCountFromJSON(json: any): LendGroupCount {
  return {
    groupId: exists(json, 'group_id') ? json.group_id : 0,
    count: exists(json, 'count') ? json.count : 0,
    limit: exists(json, 'limit') ? json.limit : 0,
    details: json.details.map(LendCountFromJSON)
  }
}
